import React from "react";
import { PageHero } from "../components/PageHero";
import { CTAStrip } from "../components/CTAStrip";

const galleryImages = [
  "IMG_7098.JPG",
  "IMG_7115.JPG",
  "IMG_7119.JPG",
  "IMG_7264.JPG",
  "IMG_7265.JPG",
  "IMG_7275.JPG",
  "IMG_7304.JPG",
  "IMG_7336.JPG",
  "IMG_7347.JPG",
  "IMG_7374.JPG",
  "IMG_7404.JPG",
  "IMG_7443.JPG",
  "IMG_7562.JPG",
  "WhatsApp Image 2026-06-28 at 19.38.56.jpeg",
  "WhatsApp Image 2026-06-28 at 19.38.56 (1).jpeg",
  "WhatsApp Image 2026-06-28 at 19.53.20.jpeg",
  "WhatsApp Image 2026-06-28 at 19.53.21.jpeg",
  "WhatsApp Image 2026-06-28 at 19.53.21 (1).jpeg",
  "WhatsApp Image 2026-06-28 at 19.53.22.jpeg",
  "WhatsApp Image 2026-06-28 at 19.53.22 (1).jpeg",
].map((file) => ({ src: `/images/${encodeURIComponent(file)}`, alt: "Moments from Spring Kids" }));

export default function Gallery() {
  return (
    <div data-testid="page-gallery">
      <PageHero title="Gallery" breadcrumb="Gallery" />

      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-2xl">
            <span className="section-label">Moments at Spring Kids</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-kid-navy">
              A Peek Into Our Everyday Joy
            </h2>
            <p className="mt-4 text-kid-navy/70 text-lg leading-relaxed">
              From art and music to outdoor play, take a look at the moments that make each day at Spring Kids special.
            </p>
          </div>

          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((img, i) => (
              <div
                key={img.src + i}
                className="rounded-3xl overflow-hidden shadow-softer"
                data-testid={`gallery-image-${i}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTAStrip />
    </div>
  );
}
